import SchoolContainer from '../../common/SchoolContainer';

const TheoryContainer = () => <SchoolContainer productType='theory' />

export default TheoryContainer